import { memo, useMemo } from 'react';
import { BlockType } from '../../../../types';
import { getBlocksToRender } from './utils';
import { BLOCK_TYPE } from '../../../../constants/generalConstants';
import { Segment } from 'semantic-ui-react';
import AnnotationsTable from '../annotationsTable';

type BlocksPropsType = {
    blocks: BlockType[];
};
const Blocks = memo(function Blocks({ blocks }: BlocksPropsType) {
    const blocksToRender = getBlocksToRender(blocks);
    return (
        <div className="overflow--auto">
            {blocksToRender.map((block, index) => {
                if (block.type === BLOCK_TYPE.TABLE) {
                    return (
                        <Segment className="overflow--auto" key={block.id}>
                            <AnnotationsTable table={block} />
                        </Segment>
                    );
                } else {
                    return <Segment key={index}>{block.content}</Segment>;
                }
            })}
        </div>
    );
});

export default Blocks;
